/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HotelsListComponent } from '@app/hotels/hotels/hotels-list/hotels-list.component';
import { extract } from '@app/core';
import { Shell } from '@app/shell/shell.service';
import { HotelsViewComponent } from '@app/hotels/hotels/hotels-view/hotels-view.component';
import { HotelBookingsListComponent } from '@app/hotels/hotel-bookings/hotel-bookings-list/hotel-bookings-list.component';
// tslint:disable-next-line:max-line-length
import { HotelBookingCancellationsListComponent } from '@app/hotels/hotel-booking-cancellations/hotel-booking-cancellations-list/hotel-booking-cancellations-list.component';
// tslint:disable-next-line:max-line-length
import { HotelBookingCancellationsViewComponent } from '@app/hotels/hotel-booking-cancellations/hotel-booking-cancellations-view/hotel-booking-cancellations-view.component';
import { HotelBookingsRoomsListComponent } from '@app/hotels/hotel-bookings/hotel-bookings-rooms-list/hotel-bookings-rooms-list.component';
import { HotelBookingsViewComponent } from '@app/hotels/hotel-bookings/hotel-bookings-view/hotel-bookings-view.component';
import { MenuService } from '@app/core/menu/menu.service';

const routes: Routes = [
  Shell.childRoutes([
    { path: 'hotels/view', component: HotelsViewComponent, data: { title: extract('Hotel view') } },
    { path: 'hotels', component: HotelsListComponent, data: { title: extract('Hotels') } },
    { path: 'hotel-bookings', component: HotelBookingsListComponent, data: { title: extract('Hotels Bookings') } },
    {
      path: 'hotel-bookings/view',
      component: HotelBookingsViewComponent,
      data: { title: extract('Hotels Bookings view') },
    },
    {
      path: 'hotel-bookings-rooms',
      component: HotelBookingsRoomsListComponent,
      data: { title: extract('Hotels Bookings Rooms') },
    },
    {
      path: 'hotel-booking-cancellations',
      component: HotelBookingCancellationsListComponent,
      data: { title: extract('Hotels Bookings Cancellations') },
    },
    {
      path: 'hotel-booking-cancellations/view',
      component: HotelBookingCancellationsViewComponent,
      data: { title: extract('Hotels Bookings Cancellation') },
    },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HotelsRoutingModule {
  constructor(menuService: MenuService) {
    menuService
      .addItem({
        key: 'hotels',
        icon: 'fal fa-hotel',
        title: 'Hotels',
      })
      .addItem({
        key: 'hotels.hotels',
        requiredPermission: 'hotels.menu',
        path: '/hotels',
        title: 'Hotels',
      })
      .addItem({
        key: 'hotels.hotel-bookings',
        requiredPermission: 'hotel_bookings.menu',
        path: '/hotel-bookings',
        title: 'Hotel Bookings',
      })
      .addItem({
        key: 'hotels.hotel-bookings-rooms',
        requiredPermission: 'hotel_booking_allotments.menu',
        path: '/hotel-bookings-rooms',
        title: 'ADV Bookings',
      })
      .addItem({
        key: 'hotels.hotel-booking-cancellations',
        requiredPermission: 'hotel_booking_cancellations.menu',
        path: '/hotel-booking-cancellations',
        title: 'Booking Cancellations',
      });
  }
}
